import Swiper from "../../../../../assets/vendor/swiper/swiper-bundle.esm.browser";

export default class PartnerSlider {
    constructor($wrapper) {
        this.$slider = $wrapper.querySelector('[data-slider]');
        this.slider = new Swiper(this.$slider, {
            loop: true,
            slidesPerView: 1,
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                }
            }
        });
    }
}